export const IconLayers = () => {
  return (
    <>
      <svg
        width="26"
        height="26"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3891_5185"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3891_5185)">
          <path
            d="M10 15.6185L3.84604 10.8429L4.51604 10.3141L10 14.5512L15.484 10.3141L16.154 10.8429L10 15.6185ZM10 12.4358L3.84604 7.66015L10 2.88452L16.154 7.66015L10 12.4358ZM10 11.3685L14.7917 7.66015L10 3.95181L5.20833 7.66015L10 11.3685Z"
            fill="#1C1B1F"
          />
        </g>
      </svg>
    </>
  );
};

export const IconEditPencil = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3891_5202"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3891_5202)">
          <path
            d="M1.66666 20V18.3333H18.3333V20H1.66666ZM4.99999 14.0225H5.89416L13.2275 6.69393L12.7837 6.23393L12.3285 5.79476L4.99999 13.1281V14.0225ZM4.16666 14.8558V12.7725L13.516 3.42789C13.6046 3.33914 13.7016 3.27448 13.8069 3.23393C13.9121 3.19337 14.0194 3.1731 14.1285 3.1731C14.2377 3.1731 14.3435 3.19337 14.4458 3.23393C14.5482 3.27448 14.6453 3.34074 14.7371 3.43268L15.5946 4.29476C15.6864 4.38351 15.7518 4.47948 15.7908 4.58268C15.8299 4.68601 15.8494 4.79275 15.8494 4.90289C15.8494 5.00608 15.829 5.11115 15.7883 5.2181C15.7478 5.32504 15.6832 5.42275 15.5946 5.51122L6.24999 14.8558H4.16666ZM13.2275 6.69393L12.7837 6.23393L12.3285 5.79476L13.2275 6.69393Z"
            fill="#1C1B1F"
          />
        </g>
      </svg>
    </>
  );
};

export const IconPublic = () => {
  return (
    <>
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.00244 13.75C6.06906 13.75 5.1915 13.5729 4.36975 13.2186C3.54813 12.8644 2.83337 12.3836 2.2255 11.7764C1.61763 11.1691 1.13644 10.455 0.781937 9.634C0.427312 8.81312 0.25 7.93594 0.25 7.00244C0.25 6.06906 0.427125 5.1915 0.781375 4.36975C1.13562 3.54812 1.61637 2.83337 2.22362 2.2255C2.83087 1.61762 3.545 1.13644 4.366 0.781937C5.18687 0.427312 6.06406 0.25 6.99756 0.25C7.93094 0.25 8.8085 0.427126 9.63025 0.781376C10.4519 1.13563 11.1666 1.61638 11.7745 2.22363C12.3824 2.83088 12.8636 3.545 13.2181 4.366C13.5727 5.18688 13.75 6.06406 13.75 6.99756C13.75 7.93094 13.5729 8.8085 13.2186 9.63025C12.8644 10.4519 12.3836 11.1666 11.7764 11.7745C11.1691 12.3824 10.455 12.8636 9.634 13.2181C8.81312 13.5727 7.93594 13.75 7.00244 13.75ZM6.25 12.9625V11.5C5.8375 11.5 5.48438 11.3531 5.19063 11.0594C4.89687 10.7656 4.75 10.4125 4.75 10V9.25L1.15 5.65C1.1125 5.875 1.07812 6.1 1.04688 6.325C1.01562 6.55 1 6.775 1 7C1 8.5125 1.49687 9.8375 2.49062 10.975C3.48438 12.1125 4.7375 12.775 6.25 12.9625ZM11.425 11.05C11.675 10.775 11.9 10.4781 12.1 10.1594C12.3 9.84063 12.4656 9.50937 12.5969 9.16562C12.7281 8.82187 12.8281 8.46875 12.8969 8.10625C12.9656 7.74375 13 7.375 13 7C13 5.76775 12.6617 4.64238 11.9853 3.62388C11.3089 2.60538 10.3971 1.87113 9.25 1.42113V1.75C9.25 2.1625 9.10313 2.51562 8.80938 2.80938C8.51562 3.10313 8.1625 3.25 7.75 3.25H6.25V4.75C6.25 4.9625 6.17812 5.14062 6.03438 5.28438C5.89062 5.42812 5.7125 5.5 5.5 5.5H4V7H8.5C8.7125 7 8.89062 7.07188 9.03438 7.21563C9.17813 7.35938 9.25 7.5375 9.25 7.75V10H10C10.325 10 10.6188 10.0969 10.8813 10.2906C11.1438 10.4844 11.325 10.7375 11.425 11.05Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconShadow = () => {
  return (
    <>
      <svg
        width="12"
        height="16"
        viewBox="0 0 12 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.50645 14.6667H9.49353V12.1667C9.49353 11.1858 9.15645 10.3477 8.48228 9.65229C7.80826 8.95674 6.98082 8.60896 5.99999 8.60896C5.01916 8.60896 4.19173 8.95674 3.5177 9.65229C2.84353 10.3477 2.50645 11.1858 2.50645 12.1667V14.6667ZM0.166656 15.5V14.6667H1.67311V12.1667C1.67311 11.1378 1.98853 10.2251 2.61937 9.42875C3.2502 8.63222 4.05867 8.15597 5.04478 8C4.05867 7.83333 3.2502 7.35444 2.61937 6.56333C1.98853 5.77222 1.67311 4.86222 1.67311 3.83333V1.33333H0.166656V0.5H11.8333V1.33333H10.3269V3.83333C10.3269 4.86222 10.0114 5.77222 9.38062 6.56333C8.74978 7.35444 7.94131 7.83333 6.9552 8C7.94131 8.15597 8.74978 8.63222 9.38062 9.42875C10.0114 10.2251 10.3269 11.1378 10.3269 12.1667V14.6667H11.8333V15.5H0.166656Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconEnergyTime = () => {
  return (
    <>
      <svg
        width="18"
        height="16"
        viewBox="0 0 18 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.01291 15.5C1.64263 15.5 1.32568 15.3682 1.06207 15.1046C0.798462 14.841 0.666656 14.5241 0.666656 14.1538V3.51296C0.666656 3.14268 0.798462 2.82573 1.06207 2.56212C1.32568 2.29851 1.64263 2.16671 2.01291 2.16671H8.58332V3.00004H2.01291C1.86332 3.00004 1.74041 3.0481 1.64416 3.14421C1.54805 3.24046 1.49999 3.36337 1.49999 3.51296V14.1538C1.49999 14.3034 1.54805 14.4263 1.64416 14.5225C1.74041 14.6187 1.86332 14.6667 2.01291 14.6667H12.6537C12.8033 14.6667 12.9262 14.6187 13.0225 14.5225C13.1186 14.4263 13.1667 14.3034 13.1667 14.1538V9.25004H14V14.1538C14 14.5241 13.8682 14.841 13.6046 15.1046C13.341 15.3682 13.024 15.5 12.6537 15.5H2.01291ZM3.77561 12.5834H4.60895V7.58337H3.77561V12.5834ZM6.91666 12.5834H7.74999V5.08337H6.91666V12.5834ZM10.0577 12.5834H10.891V10.0834H10.0577V12.5834ZM14 7.58337C13.5619 7.58337 13.1415 7.51129 12.7387 7.36712C12.336 7.22282 11.961 7.01449 11.6137 6.74212L11.0448 7.25796C10.953 7.33601 10.8512 7.37768 10.7396 7.38296C10.6279 7.38837 10.5331 7.35206 10.4552 7.274C10.3664 7.18539 10.3221 7.08712 10.3221 6.97921C10.3221 6.87129 10.3664 6.77303 10.4552 6.68442L11.0287 6.12671C10.796 5.78268 10.608 5.41796 10.4648 5.03254C10.3216 4.64712 10.25 4.2474 10.25 3.83337C10.25 2.79587 10.6156 1.9115 11.3469 1.18025C12.0781 0.449 12.9625 0.083374 14 0.083374H17.75V3.83337C17.75 4.87087 17.3844 5.75525 16.6531 6.4865C15.9219 7.21775 15.0375 7.58337 14 7.58337ZM14 6.75004C14.8101 6.75004 15.4988 6.4665 16.066 5.89942C16.6331 5.33219 16.9167 4.64351 16.9167 3.83337V0.916707H14C13.1899 0.916707 12.5012 1.20025 11.9339 1.76733C11.3669 2.33456 11.0833 3.02324 11.0833 3.83337C11.0833 4.13407 11.138 4.42317 11.2475 4.70067C11.3571 4.9783 11.4839 5.24851 11.6281 5.51129L14.1635 2.97608C14.2521 2.88733 14.3504 2.84296 14.4583 2.84296C14.5662 2.84296 14.6634 2.88615 14.7498 2.97254C14.8439 3.06671 14.891 3.16962 14.891 3.28129C14.891 3.39296 14.8451 3.49469 14.7531 3.5865L12.2339 6.10588C12.4787 6.3174 12.7546 6.47761 13.0617 6.5865C13.3687 6.69553 13.6815 6.75004 14 6.75004Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconUpload = ({
  width,
  height,
}: {
  width?: any;
  height?: any;
}) => {
  return (
    <>
      <svg
        className="icon-btn"
        width={width ? width : "5vh"}
        height={height ? height : "5vh"}
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_243_3474"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="21"
        >
          <rect
            x="0.357422"
            y="0.286133"
            width="20"
            height="20"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_243_3474)">
          <path
            d="M5.60742 16.5365C5.19076 16.5365 4.83659 16.3906 4.54492 16.099C4.25326 15.8073 4.10742 15.4531 4.10742 15.0365V12.7865H5.35742V15.0365C5.35742 15.092 5.3852 15.1476 5.44076 15.2031C5.49631 15.2587 5.55187 15.2865 5.60742 15.2865H15.1074C15.163 15.2865 15.2185 15.2587 15.2741 15.2031C15.3296 15.1476 15.3574 15.092 15.3574 15.0365V12.7865H16.6074V15.0365C16.6074 15.4531 16.4616 15.8073 16.1699 16.099C15.8783 16.3906 15.5241 16.5365 15.1074 16.5365H5.60742ZM9.73242 13.3073V6.30729L7.66992 8.34896L6.79492 7.45313L10.3574 3.89062L13.9199 7.45313L13.0449 8.34896L10.9824 6.30729V13.3073H9.73242Z"
            fill="#113F4A"
          />
        </g>
      </svg>
    </>
  );
};
export const IconEdit = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3891_5202"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3891_5202)">
          <path
            d="M1.66666 20V18.3333H18.3333V20H1.66666ZM4.99999 14.0225H5.89416L13.2275 6.69393L12.7837 6.23393L12.3285 5.79476L4.99999 13.1281V14.0225ZM4.16666 14.8558V12.7725L13.516 3.42789C13.6046 3.33914 13.7016 3.27448 13.8069 3.23393C13.9121 3.19337 14.0194 3.1731 14.1285 3.1731C14.2377 3.1731 14.3435 3.19337 14.4458 3.23393C14.5482 3.27448 14.6453 3.34074 14.7371 3.43268L15.5946 4.29476C15.6864 4.38351 15.7518 4.47948 15.7908 4.58268C15.8299 4.68601 15.8494 4.79275 15.8494 4.90289C15.8494 5.00608 15.829 5.11115 15.7883 5.2181C15.7478 5.32504 15.6832 5.42275 15.5946 5.51122L6.24999 14.8558H4.16666ZM13.2275 6.69393L12.7837 6.23393L12.3285 5.79476L13.2275 6.69393Z"
            fill="#1C1B1F"
          />
        </g>
      </svg>
    </>
  );
};

export interface IconProps {
  color?: string;
  size?: number | string;
  className?: string;
}

export const IconSave = ({ color, size = 18, className = "" }: IconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={size} width={size}  viewBox="0 -960 960 960" fill={color || "currentColor"}
      className={className} >
      <path d="M795.999-663.538v435.229q0 27.008-18.65 45.658-18.65 18.65-45.658 18.65H228.309q-27.008 0-45.658-18.65-18.65-18.65-18.65-45.658v-503.382q0-27.008 18.65-45.658 18.65-18.65 45.658-18.65h435.229l132.461 132.461ZM744-642 642-744H228.309q-5.385 0-8.847 3.462-3.462 3.462-3.462 8.847v503.382q0 5.385 3.462 8.847 3.462 3.462 8.847 3.462h503.382q5.385 0 8.847-3.462 3.462-3.462 3.462-8.847V-642ZM480-281.233q36.538 0 62.268-25.73 25.731-25.731 25.731-62.268 0-36.538-25.731-62.269-25.73-25.73-62.268-25.73t-62.268 25.73q-25.731 25.731-25.731 62.269 0 36.537 25.731 62.268 25.73 25.73 62.268 25.73ZM279.386-556.616h304.459v-123.998H279.386v123.998ZM216-629V-216v-528 115Z" />
    </svg>
  );
};

export const IconPreview = () => {
  return (
    <>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_201_7445"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="17"
        >
          <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_201_7445)">
          <path
            d="M3.33333 14.5C2.96667 14.5 2.65278 14.3694 2.39167 14.1083C2.13056 13.8472 2 13.5333 2 13.1667V3.83333C2 3.46667 2.13056 3.15278 2.39167 2.89167C2.65278 2.63056 2.96667 2.5 3.33333 2.5H12.6667C13.0333 2.5 13.3472 2.63056 13.6083 2.89167C13.8694 3.15278 14 3.46667 14 3.83333V13.1667C14 13.5333 13.8694 13.8472 13.6083 14.1083C13.3472 14.3694 13.0333 14.5 12.6667 14.5H3.33333ZM3.33333 13.1667H12.6667V5.16667H3.33333V13.1667ZM8 11.8333C7.08889 11.8333 6.275 11.5861 5.55833 11.0917C4.84167 10.5972 4.32222 9.95556 4 9.16667C4.32222 8.37778 4.84167 7.73611 5.55833 7.24167C6.275 6.74722 7.08889 6.5 8 6.5C8.91111 6.5 9.725 6.74722 10.4417 7.24167C11.1583 7.73611 11.6778 8.37778 12 9.16667C11.6778 9.95556 11.1583 10.5972 10.4417 11.0917C9.725 11.5861 8.91111 11.8333 8 11.8333ZM8 10.8333C8.62222 10.8333 9.18889 10.6861 9.7 10.3917C10.2111 10.0972 10.6111 9.68889 10.9 9.16667C10.6111 8.64444 10.2111 8.23611 9.7 7.94167C9.18889 7.64722 8.62222 7.5 8 7.5C7.37778 7.5 6.81111 7.64722 6.3 7.94167C5.78889 8.23611 5.38889 8.64444 5.1 9.16667C5.38889 9.68889 5.78889 10.0972 6.3 10.3917C6.81111 10.6861 7.37778 10.8333 8 10.8333ZM8 10.1667C8.27778 10.1667 8.51389 10.0694 8.70833 9.875C8.90278 9.68056 9 9.44444 9 9.16667C9 8.88889 8.90278 8.65278 8.70833 8.45833C8.51389 8.26389 8.27778 8.16667 8 8.16667C7.72222 8.16667 7.48611 8.26389 7.29167 8.45833C7.09722 8.65278 7 8.88889 7 9.16667C7 9.44444 7.09722 9.68056 7.29167 9.875C7.48611 10.0694 7.72222 10.1667 8 10.1667Z"
            fill="#113F4A"
          />
        </g>
      </svg>
    </>
  );
};
export const IconArchive = () => {
  return (
    <>
      <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_8_386"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="17"
        >
          <rect x="0.317017" y="0.5" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_8_386)">
          <path
            d="M8.31702 12.5L10.9837 9.83333L10.0504 8.9L8.98368 9.96667V7.16667H7.65035V9.96667L6.58368 8.9L5.65035 9.83333L8.31702 12.5ZM3.65035 5.83333V13.1667H12.9837V5.83333H3.65035ZM3.65035 14.5C3.28368 14.5 2.96979 14.3694 2.70868 14.1083C2.44757 13.8472 2.31702 13.5333 2.31702 13.1667V4.85C2.31702 4.69444 2.34202 4.54444 2.39202 4.4C2.44202 4.25556 2.51702 4.12222 2.61702 4L3.45035 2.98333C3.57257 2.82778 3.72535 2.70833 3.90868 2.625C4.09202 2.54167 4.28368 2.5 4.48368 2.5H12.1504C12.3504 2.5 12.542 2.54167 12.7254 2.625C12.9087 2.70833 13.0615 2.82778 13.1837 2.98333L14.017 4C14.117 4.12222 14.192 4.25556 14.242 4.4C14.292 4.54444 14.317 4.69444 14.317 4.85V13.1667C14.317 13.5333 14.1865 13.8472 13.9254 14.1083C13.6642 14.3694 13.3504 14.5 12.9837 14.5H3.65035ZM3.91702 4.5H12.717L12.1504 3.83333H4.48368L3.91702 4.5Z"
            fill="#113F4A"
          />
        </g>
      </svg>
    </>
  );
};
export const IconPolyline = () => {
  return (
    <>
      <h1>B</h1>
      {/* <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9167 15.9167V13.9936L4.76291 10.9167H0.916656V6.75004H4.27562L6.74999 3.91025V0.083374H10.9167V4.25004H7.5577L5.08332 7.08983V10.1315L10.9167 13.0482V11.75H15.0833V15.9167H10.9167ZM7.58332 3.41671H10.0833V0.916707H7.58332V3.41671ZM1.74999 10.0834H4.24999V7.58337H1.74999V10.0834ZM11.75 15.0834H14.25V12.5834H11.75V15.0834Z" fill="#1C1B1F"/>
     </svg> */}
    </>
  );
};
export const IconBigPolyline = () => {
  return (
    <>
      <svg
        id="polygon1"
        data-type="polygon"
        className="cursor-pointer"
        width="36"
        height="36"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4083"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4083)">
          <path
            d="M10 14.6663V12.9997L5.33333 10.6663H2V6.66634H4.86667L6.66667 4.59967V1.33301H10.6667V5.33301H7.8L6 7.39967V9.49967L10 11.4997V10.6663H14V14.6663H10ZM8 3.99967H9.33333V2.66634H8V3.99967ZM3.33333 9.33301H4.66667V7.99967H3.33333V9.33301ZM11.3333 13.333H12.6667V11.9997H11.3333V13.333Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconBigPolyline2 = () => {
  return (
    <>
      <svg
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.33333 15.5V11.9583L12.3125 1C12.4792 0.833333 12.6667 0.708333 12.875 0.625C13.0833 0.541667 13.2917 0.5 13.5 0.5C13.7222 0.5 13.934 0.541667 14.1354 0.625C14.3368 0.708333 14.5139 0.833333 14.6667 1L15.8333 2.16667C16 2.31944 16.125 2.49653 16.2083 2.69792C16.2917 2.89931 16.3333 3.11111 16.3333 3.33333C16.3333 3.54167 16.2917 3.75 16.2083 3.95833C16.125 4.16667 16 4.35417 15.8333 4.52083L4.875 15.5H1.33333ZM3 13.8333H4.16667L12.3542 5.66667L11.7708 5.0625L11.1667 4.47917L3 12.6667V13.8333ZM11.7708 5.0625L11.1667 4.47917L12.3542 5.66667L11.7708 5.0625ZM9.66667 15.5C10.6944 15.5 11.6458 15.2431 12.5208 14.7292C13.3958 14.2153 13.8333 13.5 13.8333 12.5833C13.8333 12.0833 13.7014 11.6528 13.4375 11.2917C13.1736 10.9306 12.8194 10.6181 12.375 10.3542L11.1458 11.5833C11.4653 11.7222 11.7153 11.875 11.8958 12.0417C12.0764 12.2083 12.1667 12.3889 12.1667 12.5833C12.1667 12.9028 11.9132 13.191 11.4063 13.4479C10.8993 13.7049 10.3194 13.8333 9.66667 13.8333C9.43056 13.8333 9.23264 13.9132 9.07292 14.0729C8.9132 14.2326 8.83333 14.4306 8.83333 14.6667C8.83333 14.9028 8.9132 15.1007 9.07292 15.2604C9.23264 15.4201 9.43056 15.5 9.66667 15.5ZM1.8125 9.125L3.0625 7.875C2.78472 7.76389 2.56597 7.64931 2.40625 7.53125C2.24653 7.41319 2.16667 7.29167 2.16667 7.16667C2.16667 7 2.29167 6.83333 2.54167 6.66667C2.79167 6.5 3.31944 6.24306 4.125 5.89583C5.34722 5.36806 6.15972 4.88889 6.5625 4.45833C6.96528 4.02778 7.16667 3.54167 7.16667 3C7.16667 2.23611 6.86111 1.62847 6.25 1.17708C5.63889 0.725694 4.83333 0.5 3.83333 0.5C3.20833 0.5 2.64931 0.611111 2.15625 0.833333C1.66319 1.05556 1.28472 1.32639 1.02083 1.64583C0.868056 1.82639 0.805556 2.02778 0.833333 2.25C0.861111 2.47222 0.965278 2.65278 1.14583 2.79167C1.32639 2.94444 1.52778 3.00694 1.75 2.97917C1.97222 2.95139 2.15972 2.86111 2.3125 2.70833C2.50694 2.51389 2.72222 2.375 2.95833 2.29167C3.19444 2.20833 3.48611 2.16667 3.83333 2.16667C4.40278 2.16667 4.82292 2.25 5.09375 2.41667C5.36458 2.58333 5.5 2.77778 5.5 3C5.5 3.19444 5.37847 3.37153 5.13542 3.53125C4.89236 3.69097 4.33333 3.97222 3.45833 4.375C2.34722 4.86111 1.57639 5.30208 1.14583 5.69792C0.715278 6.09375 0.5 6.58333 0.5 7.16667C0.5 7.61111 0.618056 7.98958 0.854167 8.30208C1.09028 8.61458 1.40972 8.88889 1.8125 9.125Z"
          fill="#40656E"
        />
      </svg>
    </>
  );
};
export const IconRectangle = () => {
  return (
    <>
      <svg
        width="16"
        height="12"
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 11.8333V0.166626H15.5V11.8333H0.5ZM1.33333 11H14.6667V0.999959H1.33333V11Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconMeasurement = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_3891_5211"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_3891_5211)">
          <path
            d="M3.84625 14.1667C3.46264 14.1667 3.14236 14.0382 2.88542 13.7813C2.62847 13.5243 2.5 13.2041 2.5 12.8205V7.17962C2.5 6.79601 2.62847 6.47574 2.88542 6.21879C3.14236 5.96185 3.46264 5.83337 3.84625 5.83337H16.1538C16.5374 5.83337 16.8576 5.96185 17.1146 6.21879C17.3715 6.47574 17.5 6.79601 17.5 7.17962V12.8205C17.5 13.2041 17.3715 13.5243 17.1146 13.7813C16.8576 14.0382 16.5374 14.1667 16.1538 14.1667H3.84625ZM3.84625 13.3334H16.1538C16.2821 13.3334 16.3997 13.28 16.5065 13.1732C16.6133 13.0664 16.6667 12.9488 16.6667 12.8205V7.17962C16.6667 7.05129 16.6133 6.93372 16.5065 6.82692C16.3997 6.72011 16.2821 6.66671 16.1538 6.66671H13.75V9.359H12.9167V6.66671H10.4167V9.359H9.58333V6.66671H7.08333V9.359H6.25V6.66671H3.84625C3.71792 6.66671 3.60035 6.72011 3.49354 6.82692C3.38674 6.93372 3.33333 7.05129 3.33333 7.17962V12.8205C3.33333 12.9488 3.38674 13.0664 3.49354 13.1732C3.60035 13.28 3.71792 13.3334 3.84625 13.3334Z"
            fill="#1C1B1F"
          />
        </g>
      </svg>
    </>
  );
};
export const IconBigRectangle = () => {
  return (
    <>
      <svg
        id="select-by-rectangle"
        data-type="rectangle"
        className="cursor-pointer"
        width="36"
        height="36"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4086"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4086)">
          <path
            d="M1.3335 13.3337V2.66699H14.6668V13.3337H1.3335ZM2.66683 12.0003H13.3335V4.00033H2.66683V12.0003Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconScale = () => {
  return (
    <>
      <svg
        width="16"
        className="cursor-pointer"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4089"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4089)">
          <path
            d="M2.66683 12C2.30016 12 1.98638 11.8696 1.7255 11.6087C1.46416 11.3473 1.3335 11.0333 1.3335 10.6667V5.33333C1.3335 4.96667 1.46416 4.65289 1.7255 4.392C1.98638 4.13067 2.30016 4 2.66683 4H13.3335C13.7002 4 14.0142 4.13067 14.2755 4.392C14.5364 4.65289 14.6668 4.96667 14.6668 5.33333V10.6667C14.6668 11.0333 14.5364 11.3473 14.2755 11.6087C14.0142 11.8696 13.7002 12 13.3335 12H2.66683ZM2.66683 10.6667H13.3335V5.33333H11.3335V8H10.0002V5.33333H8.66683V8H7.3335V5.33333H6.00016V8H4.66683V5.33333H2.66683V10.6667Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconDelete = () => {
  return (
    <>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.34624 13.6667C1.97332 13.6667 1.65568 13.5356 1.39332 13.2733C1.1311 13.011 0.99999 12.6933 0.99999 12.3204V2.00001H0.166656V1.16668H3.49999V0.525635H8.49999V1.16668H11.8333V2.00001H11V12.3204C11 12.704 10.8715 13.0243 10.6146 13.2813C10.3576 13.5382 10.0374 13.6667 9.65374 13.6667H2.34624ZM10.1667 2.00001H1.83332V12.3204C1.83332 12.47 1.88138 12.5929 1.97749 12.6892C2.07374 12.7853 2.19666 12.8333 2.34624 12.8333H9.65374C9.78207 12.8333 9.89964 12.7799 10.0064 12.6731C10.1133 12.5663 10.1667 12.4488 10.1667 12.3204V2.00001ZM4.17312 11.1667H5.00645V3.66668H4.17312V11.1667ZM6.99353 11.1667H7.82687V3.66668H6.99353V11.1667Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconVisible = ({color="#40656E"}:{color?:string}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="2vh"
        viewBox="0 -960 960 960"
        width="4vh"
        fill={color}
      >
        <path d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
      </svg>
    </>
  );
};
export const IconInVisible = ({color="#40656E"}:{color?:string}) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="2vh"
        viewBox="0 -960 960 960"
        width="4vh"
        fill={color}
      >
        <path d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z" />
      </svg>
    </>
  );
};
export const IconBigDelete = () => {
  return (
    <>
      <svg
        width="36"
        id="delete_layer"
        className="cursor-pointer"
        height="36"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4092"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4092)">
          <path
            d="M4.6665 14C4.29984 14 3.98606 13.8696 3.72517 13.6087C3.46384 13.3473 3.33317 13.0333 3.33317 12.6667V4H2.6665V2.66667H5.99984V2H9.99984V2.66667H13.3332V4H12.6665V12.6667C12.6665 13.0333 12.5361 13.3473 12.2752 13.6087C12.0138 13.8696 11.6998 14 11.3332 14H4.6665ZM11.3332 4H4.6665V12.6667H11.3332V4ZM5.99984 11.3333H7.33317V5.33333H5.99984V11.3333ZM8.6665 11.3333H9.99984V5.33333H8.6665V11.3333Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconRefresh = () => {
  return (
    <>
      <svg
        width="12"
        height="14"
        viewBox="0 0 12 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.16666 13.5929C3.7211 13.3953 2.52638 12.7508 1.58249 11.6594C0.638601 10.5682 0.166656 9.29281 0.166656 7.83336C0.166656 7.05558 0.320476 6.31065 0.628115 5.59857C0.935893 4.88649 1.35902 4.25538 1.89749 3.70524L2.49207 4.29961C1.99624 4.76128 1.6236 5.29656 1.37416 5.90545C1.12471 6.51447 0.99999 7.15711 0.99999 7.83336C0.99999 9.05558 1.39152 10.1301 2.17457 11.0569C2.95777 11.9837 3.95513 12.5513 5.16666 12.7596V13.5929ZM6.83332 13.625V12.7917C8.03096 12.5267 9.02485 11.937 9.81499 11.0225C10.605 10.1079 11 9.04489 11 7.83336C11 6.44447 10.5139 5.26392 9.54166 4.2917C8.56943 3.31947 7.38888 2.83336 5.99999 2.83336H5.4727L6.80603 4.1667L6.21624 4.75649L3.87666 2.4167L6.21624 0.0769043L6.80603 0.666696L5.4727 2.00003H5.99999C7.6261 2.00003 9.00485 2.56572 10.1362 3.69711C11.2676 4.8285 11.8333 6.20725 11.8333 7.83336C11.8333 9.28961 11.3587 10.558 10.4094 11.6386C9.4602 12.7193 8.26818 13.3814 6.83332 13.625Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const Icon3D = () => {
  return (
    <>
      <svg
        id="3DButton"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="20"
        height="20"
      >
        <path
          d="M448-167 228-296q-13.775-8.426-21.387-22.213Q199-332 199-348v-257q0-16 7.613-29.787Q214.225-648.574 228-657l221-131q14-8 31-8t31 8l221 131q13.775 8.426 21.388 22.213Q761-621 761-605v257q0 16-7.875 29.787Q745.25-304.426 731-296L508-167q-14.328 8-30.164 8Q462-159 448-167Zm2-69v-224L260-569v219l190 114Zm60 0 191-114v-219L510-460v224ZM80-691v-129q0-24.75 17.625-42.375T140-880h129v60H140v129H80ZM269-80H140q-24.75 0-42.375-17.625T80-140v-129h60v129h129v60Zm422 0v-60h129v-129h60v129q0 24.75-17.625 42.375T820-80H691Zm129-611v-129H691v-60h129q24.75 0 42.375 17.625T880-820v129h-60ZM480-514l190-110-190-109-190 109 190 110Zm0 25Zm0-25Zm30 54Zm-60 0Z"
          fill="#40656E"
        />
      </svg>
    </>
  );
};
export const IconPin = () => {
  return (
    <>
      <svg
        id="PinButton"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 -960 960 960"
        width="20"
        height="20"
      >
        <path
          d="M480-298q103.95-83.86 156.975-161.43Q690-537 690-604q0-59-21.5-100t-53.009-66.88q-31.51-25.881-68.271-37.5Q510.459-820 480-820q-30.459 0-67.22 11.62-36.761 11.619-68.271 37.5Q313-745 291.5-704T270-604q0 67 53.025 144.57T480-298Zm0 76Q343-325 276.5-419.199q-66.5-94.2-66.5-184.554Q210-672 234.5-723.5T298-810q39-35 86.98-52.5 47.98-17.5 95-17.5T575-862.5q48 17.5 87 52.5t63.5 86.533Q750-671.934 750-603.544 750-513 683.5-419 617-325 480-222Zm.089-318Q509-540 529.5-560.589q20.5-20.588 20.5-49.5Q550-639 529.411-659.5q-20.588-20.5-49.5-20.5Q451-680 430.5-659.411q-20.5 20.588-20.5 49.5Q410-581 430.589-560.5q20.588 20.5 49.5 20.5ZM210-80v-60h540v60H210Zm270-524Z"
          fill="#40656E"
        />
      </svg>
    </>
  );
};
export const IconCircle = () => {
  return (
    <svg
      id="circle"
      data-type="circle"
      className="cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 -960 960 960"
    >
      <path
        d="M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-156t86-127Q252-817 325-848.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Zm0-60q142 0 241-99.5T820-480q0-142-99-241t-241-99q-141 0-240.5 99T140-480q0 141 99.5 240.5T480-140Zm0-340Z"
        fill="#40656E"
      />
    </svg>
  );
};
export const IconTime = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4107"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4107)">
          <path
            d="M5.33317 13.333H10.6665V11.333C10.6665 10.5997 10.4054 9.9719 9.88317 9.44967C9.36095 8.92745 8.73317 8.66634 7.99984 8.66634C7.2665 8.66634 6.63873 8.92745 6.1165 9.44967C5.59428 9.9719 5.33317 10.5997 5.33317 11.333V13.333ZM2.6665 14.6663V13.333H3.99984V11.333C3.99984 10.6552 4.15828 10.019 4.47517 9.42434C4.79162 8.83012 5.23317 8.35523 5.79984 7.99967C5.23317 7.64412 4.79162 7.16901 4.47517 6.57434C4.15828 5.98012 3.99984 5.34412 3.99984 4.66634V2.66634H2.6665V1.33301H13.3332V2.66634H11.9998V4.66634C11.9998 5.34412 11.8416 5.98012 11.5252 6.57434C11.2083 7.16901 10.7665 7.64412 10.1998 7.99967C10.7665 8.35523 11.2083 8.83012 11.5252 9.42434C11.8416 10.019 11.9998 10.6552 11.9998 11.333V13.333H13.3332V14.6663H2.6665Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconBar = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4110"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4110)">
          <path
            d="M1.99984 14.6663C1.63317 14.6663 1.31939 14.5359 1.0585 14.275C0.797171 14.0137 0.666504 13.6997 0.666504 13.333V3.99967C0.666504 3.63301 0.797171 3.31923 1.0585 3.05834C1.31939 2.79701 1.63317 2.66634 1.99984 2.66634H7.33317V3.99967H1.99984V13.333H11.3332V9.33301H12.6665V13.333C12.6665 13.6997 12.5361 14.0137 12.2752 14.275C12.0138 14.5359 11.6998 14.6663 11.3332 14.6663H1.99984ZM3.33317 11.9997V7.33301H4.6665V11.9997H3.33317ZM5.99984 11.9997V5.33301H7.33317V11.9997H5.99984ZM8.6665 11.9997V9.33301H9.99984V11.9997H8.6665ZM11.9998 7.99967C11.6443 7.99967 11.3083 7.94967 10.9918 7.84967C10.6749 7.74967 10.3832 7.60523 10.1165 7.41634L9.8665 7.64967C9.73317 7.78301 9.57762 7.84967 9.39984 7.84967C9.22206 7.84967 9.0665 7.78301 8.93317 7.64967C8.79984 7.51634 8.73317 7.36079 8.73317 7.18301C8.73317 7.00523 8.79984 6.84967 8.93317 6.71634L9.19984 6.44967C9.03317 6.19412 8.90273 5.91634 8.8085 5.61634C8.71384 5.31634 8.6665 4.99967 8.6665 4.66634C8.6665 3.71079 8.99717 2.91634 9.6585 2.28301C10.3194 1.64967 11.0998 1.33301 11.9998 1.33301H15.3332V4.66634C15.3332 5.55523 15.0165 6.33301 14.3832 6.99967C13.7498 7.66634 12.9554 7.99967 11.9998 7.99967ZM11.9998 6.66634C12.5554 6.66634 13.0276 6.4719 13.4165 6.08301C13.8054 5.69412 13.9998 5.2219 13.9998 4.66634V2.66634H11.9998C11.4665 2.66634 10.9998 2.85523 10.5998 3.23301C10.1998 3.61079 9.99984 4.08856 9.99984 4.66634C9.99984 4.81079 10.0136 4.95234 10.0412 5.09101C10.0692 5.23012 10.1109 5.36079 10.1665 5.48301L11.8998 3.74967C12.0332 3.61634 12.1887 3.54967 12.3665 3.54967C12.5443 3.54967 12.6998 3.61634 12.8332 3.74967C12.9665 3.88301 13.0332 4.04145 13.0332 4.22501C13.0332 4.40812 12.9665 4.56634 12.8332 4.69967L11.0998 6.43301C11.2332 6.49967 11.3749 6.55523 11.5252 6.59967C11.6749 6.64412 11.8332 6.66634 11.9998 6.66634Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconAdd = () => {
  return (
    <>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.58333 5.41667H0V4.58333H4.58333V0H5.41667V4.58333H10V5.41667H5.41667V10H4.58333V5.41667Z"
          fill="#1C1B1F"
        />
      </svg>
    </>
  );
};
export const IconRSBEdit = ({ newMapToolstitle, color }: { newMapToolstitle?: boolean, color?: string }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_5931_30970"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5931_30970)">
          <path
            d="M1.83325 22V20.1667H20.1666V22H1.83325ZM5.49992 15.4248H6.4835L14.5502 7.3634L14.062 6.8574L13.5613 6.37431L5.49992 14.441V15.4248ZM4.58325 16.3415V14.0498L14.8676 3.77075C14.965 3.67312 15.0717 3.60201 15.1875 3.55739C15.3033 3.51278 15.4212 3.49048 15.5413 3.49048C15.6614 3.49048 15.7777 3.51278 15.8903 3.55739C16.0029 3.60201 16.1097 3.67488 16.2107 3.77602L17.154 4.72431C17.2549 4.82194 17.3269 4.92751 17.3698 5.04102C17.4128 5.15469 17.4342 5.2721 17.4342 5.39325C17.4342 5.50676 17.4118 5.62234 17.3671 5.73998C17.3225 5.85762 17.2514 5.9651 17.154 6.06242L6.87492 16.3415H4.58325ZM14.5502 7.3634L14.062 6.8574L13.5613 6.37431L14.5502 7.3634Z"
            fill={newMapToolstitle === true ? "#1C1B1F" : color ?? color}
          />
        </g>
      </svg>
    </>
  );
};
export const IconRSBDelete = ({ newMapToolstitle, color }: { newMapToolstitle?: boolean, color?: string }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_5931_30976"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5931_30976)">
          <path
            d="M6.98079 18.3333C6.57059 18.3333 6.22118 18.1891 5.93259 17.9007C5.64414 17.6121 5.49992 17.2627 5.49992 16.8524V5.49999H4.58325V4.58332H8.24992V3.87817H13.7499V4.58332H17.4166V5.49999H16.4999V16.8524C16.4999 17.2744 16.3586 17.6267 16.076 17.9094C15.7933 18.192 15.441 18.3333 15.019 18.3333H6.98079ZM15.5833 5.49999H6.41659V16.8524C6.41659 17.017 6.46945 17.1522 6.57517 17.2581C6.68104 17.3638 6.81625 17.4167 6.98079 17.4167H15.019C15.1602 17.4167 15.2895 17.3579 15.407 17.2404C15.5245 17.1229 15.5833 16.9936 15.5833 16.8524V5.49999ZM8.99036 15.5833H9.90702V7.33332H8.99036V15.5833ZM12.0928 15.5833H13.0095V7.33332H12.0928V15.5833Z"
            fill={newMapToolstitle === true ? "#1C1B1F" : color ?? color}
          />
        </g>
      </svg>
    </>
  );
};
export const IconRSBSave = ({ newMapToolstitle, color }: { newMapToolstitle?: boolean, color?: string }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_5931_30973"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill={'#D9D9D9'} />
        </mask>
        <g mask="url(#mask0_5931_30973)">
          <path
            d="M18.3334 6.80438V16.8524C18.3334 17.2744 18.1921 17.6267 17.9095 17.9093C17.6268 18.192 17.2745 18.3333 16.8525 18.3333H5.14762C4.72565 18.3333 4.37335 18.192 4.09071 17.9093C3.80807 17.6267 3.66675 17.2744 3.66675 16.8524V5.1475C3.66675 4.72553 3.80807 4.37322 4.09071 4.09058C4.37335 3.80795 4.72565 3.66663 5.14762 3.66663H15.1957L18.3334 6.80438ZM17.4167 7.19579L14.8042 4.58329H5.14762C4.98308 4.58329 4.84787 4.63615 4.742 4.74188C4.63628 4.84775 4.58341 4.98296 4.58341 5.1475V16.8524C4.58341 17.017 4.63628 17.1522 4.742 17.258C4.84787 17.3638 4.98308 17.4166 5.14762 17.4166H16.8525C17.0171 17.4166 17.1523 17.3638 17.2582 17.258C17.3639 17.1522 17.4167 17.017 17.4167 16.8524V7.19579ZM11.0001 15.1603C11.5055 15.1603 11.9374 14.981 12.2958 14.6226C12.6542 14.2642 12.8334 13.8323 12.8334 13.3269C12.8334 12.8215 12.6542 12.3896 12.2958 12.0312C11.9374 11.6728 11.5055 11.4936 11.0001 11.4936C10.4947 11.4936 10.0628 11.6728 9.70437 12.0312C9.34596 12.3896 9.16675 12.8215 9.16675 13.3269C9.16675 13.8323 9.34596 14.2642 9.70437 14.6226C10.0628 14.981 10.4947 15.1603 11.0001 15.1603ZM6.20523 8.9551H13.0096V6.20511H6.20523V8.9551Z"
            // fill="#1C1B1F"

            fill={newMapToolstitle === true ? "#1C1B1F" : color ?? color}
          />
        </g>
      </svg>
    </>
  );
};
export const IconRSBAddRow = ({ newMapToolstitle }: { newMapToolstitle?: boolean }) => {
  return (
    <>
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"

      >
        <mask
          id="mask0_5931_30967"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_5931_30967)">
          <path
            d="M3.20825 14.2084V13.2917H9.62492V14.2084H3.20825ZM3.20825 10.5417V9.62504H13.2916V10.5417H3.20825ZM3.20825 6.87504V5.95837H13.2916V6.87504H3.20825ZM15.1249 17.875V14.2084H11.4583V13.2917H15.1249V9.62504H16.0416V13.2917H19.7083V14.2084H16.0416V17.875H15.1249Z"
            fill={newMapToolstitle === true ? "#1C1B1F" : '#1C1B1F'}
          />
        </g>
      </svg>
    </>
  );
};

export const IconUploadImg = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className="fill-white size-6"><path d="M440-440ZM132.31-140Q102-140 81-161q-21-21-21-51.31v-455.38Q60-698 81-719q21-21 51.31-21h122.15l74-80h223.85v60H354.62l-73.39 80H132.31q-5.39 0-8.85 3.46t-3.46 8.85v455.38q0 5.39 3.46 8.85t8.85 3.46h615.38q5.39 0 8.85-3.46t3.46-8.85v-340h60v340Q820-182 799-161q-21 21-51.31 21H132.31ZM760-680v-80h-80v-60h80v-80h60v80h80v60h-80v80h-60ZM440-275.39q68.85 0 116.73-47.88 47.88-47.88 47.88-116.73t-47.88-116.73Q508.85-604.61 440-604.61t-116.73 47.88Q275.39-508.85 275.39-440t47.88 116.73q47.88 47.88 116.73 47.88Zm0-59.99q-44.31 0-74.46-30.16-30.16-30.15-30.16-74.46 0-44.31 30.16-74.46 30.15-30.16 74.46-30.16 44.31 0 74.46 30.16 30.16 30.15 30.16 74.46 0 44.31-30.16 74.46-30.15 30.16-74.46 30.16Z" /></svg>
    </>
  );
};
export const IconMarker = () => {
  return (
    <>
      <svg
        width="2.4vh"
        height="2.4vh"
        className="icon-btn pl-0.4"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_153_1049"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="14"
          height="14"
        >
          <rect width="14" height="14" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_153_1049)">
          <path
            d="M7.00008 9.61086C7.96258 8.83309 8.68941 8.08448 9.18058 7.36503C9.67136 6.64559 9.91675 5.96989 9.91675 5.33795C9.91675 4.7935 9.81719 4.32917 9.61808 3.94495C9.41858 3.56111 9.173 3.25 8.88133 3.01161C8.58966 2.77361 8.27369 2.60114 7.93341 2.4942C7.59314 2.38725 7.28202 2.33378 7.00008 2.33378C6.71814 2.33378 6.40702 2.38725 6.06675 2.4942C5.72647 2.60114 5.4105 2.77361 5.11883 3.01161C4.82716 3.25 4.58178 3.56111 4.38266 3.94495C4.18316 4.32917 4.08341 4.7935 4.08341 5.33795C4.08341 5.96989 4.3288 6.64559 4.81958 7.36503C5.31075 8.08448 6.03758 8.83309 7.00008 9.61086ZM7.00008 11.0838C5.62925 10.0727 4.60589 9.09072 3.93 8.13795C3.2545 7.18517 2.91675 6.25184 2.91675 5.33795C2.91675 4.64767 3.0408 4.04236 3.28891 3.52203C3.53664 3.00209 3.85494 2.56711 4.24383 2.21711C4.63272 1.86711 5.07022 1.60461 5.55633 1.42961C6.04244 1.25461 6.52369 1.16711 7.00008 1.16711C7.47647 1.16711 7.95772 1.25461 8.44383 1.42961C8.92994 1.60461 9.36744 1.86711 9.75633 2.21711C10.1452 2.56711 10.4637 3.00209 10.7118 3.52203C10.9596 4.04236 11.0834 4.64767 11.0834 5.33795C11.0834 6.25184 10.7455 7.18517 10.0696 8.13795C9.39408 9.09072 8.37091 10.0727 7.00008 11.0838ZM7.00008 6.41711C7.32091 6.41711 7.59566 6.30278 7.82433 6.07411C8.05261 5.84584 8.16675 5.57128 8.16675 5.25045C8.16675 4.92961 8.05261 4.65486 7.82433 4.4262C7.59566 4.19792 7.32091 4.08378 7.00008 4.08378C6.67925 4.08378 6.40469 4.19792 6.17641 4.4262C5.94775 4.65486 5.83341 4.92961 5.83341 5.25045C5.83341 5.57128 5.94775 5.84584 6.17641 6.07411C6.40469 6.30278 6.67925 6.41711 7.00008 6.41711ZM2.91675 12.8338V11.6671H11.0834V12.8338H2.91675Z"
            fill="#28525C"
          />
        </g>
      </svg>
    </>
  );
};
export const IconAddFeature = () => {
  return (
    <>
      <svg
        id="featureAdd"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4121"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4121)">
          <path
            d="M7.3335 12.6673V8.66732H3.3335V7.33398H7.3335V3.33398H8.66683V7.33398H12.6668V8.66732H8.66683V12.6673H7.3335Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconNoteAdd = () => {
  return (
    <>
      <svg
        className="icon-btn"
        width="2.2vh"
        height="2.2vh"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_71_316"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_71_316)">
          <path
            d="M10.0833 16.5H11.9166V13.75H14.6666V11.9167H11.9166V9.16671H10.0833V11.9167H7.33329V13.75H10.0833V16.5ZM5.49996 20.1667C4.99579 20.1667 4.5642 19.9872 4.20517 19.6282C3.84614 19.2691 3.66663 18.8375 3.66663 18.3334V3.66671C3.66663 3.16254 3.84614 2.73094 4.20517 2.37192C4.5642 2.01289 4.99579 1.83337 5.49996 1.83337H12.8333L18.3333 7.33337V18.3334C18.3333 18.8375 18.1538 19.2691 17.7948 19.6282C17.4357 19.9872 17.0041 20.1667 16.5 20.1667H5.49996ZM11.9166 8.25004V3.66671H5.49996V18.3334H16.5V8.25004H11.9166Z"
            fill="#FAF3E6"
          />
        </g>
      </svg>
    </>
  );
};
export const IconSim = () => {
  return (
    <>
      <svg className="mr-0.2" width="1.6vh" height="1.6vh" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.00016 13.1667L10.3335 9.83341L9.16683 8.66675L7.8335 9.95841V6.50008H6.16683V9.95841L4.8335 8.66675L3.66683 9.83341L7.00016 13.1667ZM2.00016 17.3334C1.54183 17.3334 1.14947 17.1702 0.823079 16.8438C0.496691 16.5174 0.333496 16.1251 0.333496 15.6667V5.66675L5.3335 0.666748H12.0002C12.4585 0.666748 12.8509 0.829942 13.1772 1.15633C13.5036 1.48272 13.6668 1.87508 13.6668 2.33341V15.6667C13.6668 16.1251 13.5036 16.5174 13.1772 16.8438C12.8509 17.1702 12.4585 17.3334 12.0002 17.3334H2.00016ZM2.00016 15.6667H12.0002V2.33341H6.04183L2.00016 6.37508V15.6667Z" fill="#40656E" />
      </svg>

    </>
  );
};
export const IconSearch = () => {
  return (
    <>
      <svg
        className="icon-btn"
        width="2.2vh"
        height="2.2vh"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_6_66888"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_6_66888)">
          <path
            d="M17.9667 19.2495L12.1917 13.4745C11.7333 13.8412 11.2062 14.1315 10.6104 14.3453C10.0146 14.5592 9.38055 14.6662 8.70833 14.6662C7.04306 14.6662 5.63383 14.0896 4.48067 12.9364C3.32689 11.7826 2.75 10.3731 2.75 8.70784C2.75 7.04257 3.32689 5.63304 4.48067 4.47926C5.63383 3.3261 7.04306 2.74951 8.70833 2.74951C10.3736 2.74951 11.7831 3.3261 12.9369 4.47926C14.0901 5.63304 14.6667 7.04257 14.6667 8.70784C14.6667 9.38007 14.5597 10.0141 14.3458 10.6099C14.1319 11.2058 13.8417 11.7328 13.475 12.1912L19.25 17.9662L17.9667 19.2495ZM8.70833 12.8328C9.85417 12.8328 10.8283 12.432 11.6307 11.6302C12.4324 10.8278 12.8333 9.85368 12.8333 8.70784C12.8333 7.56201 12.4324 6.5879 11.6307 5.78551C10.8283 4.98373 9.85417 4.58284 8.70833 4.58284C7.5625 4.58284 6.58839 4.98373 5.786 5.78551C4.98422 6.5879 4.58333 7.56201 4.58333 8.70784C4.58333 9.85368 4.98422 10.8278 5.786 11.6302C6.58839 12.432 7.5625 12.8328 8.70833 12.8328Z"
            fill="#587880"
          />
        </g>
      </svg>
    </>
  );
};
export const IconSortMenu = () => {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_184_3240"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="18"
          height="18"
        >
          <rect width="18" height="18" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_184_3240)">
          <path
            d="M2.25 13.5V12H6.75V13.5H2.25ZM2.25 9.75V8.25H11.25V9.75H2.25ZM2.25 6V4.5H15.75V6H2.25Z"
            fill="#587880"
          />
        </g>
      </svg>
    </>
  );
};
export const IconFilter = () => {
  return (
    <>
      <svg
        className="icon-btn"
        width="2.2vh"
        height="2.2vh"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_78_1102"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="22"
          height="22"
        >
          <rect width="22" height="22" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_78_1102)">
          <path
            d="M10.0833 18.3333C9.82361 18.3333 9.60591 18.2454 9.43021 18.0698C9.25452 17.8941 9.16667 17.6763 9.16667 17.4166V11.9166L3.85 5.13329C3.62084 4.82774 3.58646 4.5069 3.74688 4.17079C3.90729 3.83468 4.18611 3.66663 4.58334 3.66663H17.4167C17.8139 3.66663 18.0927 3.83468 18.2531 4.17079C18.4135 4.5069 18.3792 4.82774 18.15 5.13329L12.8333 11.9166V17.4166C12.8333 17.6763 12.7455 17.8941 12.5698 18.0698C12.3941 18.2454 12.1764 18.3333 11.9167 18.3333H10.0833ZM11 11.275L15.5375 5.49996H6.4625L11 11.275Z"
            fill="#587880"
          />
        </g>
      </svg>
    </>
  );
};
export const IconSub = () => {
  return (
    <>
      <svg
        width="10"
        height="2"
        viewBox="0 0 10 2"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0 1.41671V0.583374H10V1.41671H0Z" fill="#1C1B1F" />
      </svg>
    </>
  );
};

export const DeleteGraphic = () => {
  return (
    <>
      <svg
        id="deleteGraphic"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <mask
          id="mask0_523_4124"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_523_4124)">
          <path
            d="M3.3335 8.66732V7.33398H12.6668V8.66732H3.3335Z"
            fill="#40656E"
          />
        </g>
      </svg>
    </>
  );
};
export const IconCloudUpload = () => {
  return (
    <>
      <svg
        className="icon-btn"
        width="22"
        height="22"
        viewBox="0 0 23 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.00829 16.1045C4.52596 16.1045 3.25947 15.5914 2.2088 14.5652C1.15814 13.539 0.632812 12.2847 0.632812 10.8024C0.632812 9.5318 1.01561 8.39969 1.78121 7.40605C2.54681 6.4124 3.5486 5.77711 4.78659 5.5002C5.19382 4.00158 6.00829 2.78802 7.22999 1.85953C8.45169 0.931043 9.83628 0.466797 11.3838 0.466797C13.2896 0.466797 14.9063 1.13059 16.2339 2.45817C17.5615 3.78575 18.2253 5.40246 18.2253 7.30831C19.3492 7.43863 20.2818 7.92323 21.023 8.76213C21.7641 9.60103 22.1347 10.5825 22.1347 11.7064C22.1347 12.9281 21.7071 13.9666 20.8519 14.8218C19.9967 15.6769 18.9583 16.1045 17.7366 16.1045H12.3611C11.8236 16.1045 11.3634 15.9131 10.9806 15.5303C10.5978 15.1475 10.4064 14.6874 10.4064 14.1498V9.11643L8.84263 10.6313L7.47433 9.26303L11.3838 5.35359L15.2932 9.26303L13.9249 10.6313L12.3611 9.11643V14.1498H17.7366C18.4207 14.1498 18.999 13.9136 19.4714 13.4412C19.9438 12.9688 20.18 12.3906 20.18 11.7064C20.18 11.0223 19.9438 10.444 19.4714 9.97161C18.999 9.49922 18.4207 9.26303 17.7366 9.26303H16.2706V7.30831C16.2706 5.9563 15.7941 4.80383 14.8412 3.8509C13.8882 2.89798 12.7358 2.42152 11.3838 2.42152C10.0317 2.42152 8.87928 2.89798 7.92636 3.8509C6.97343 4.80383 6.49697 5.9563 6.49697 7.30831H6.00829C5.06351 7.30831 4.25719 7.64224 3.58932 8.3101C2.92146 8.97797 2.58753 9.78429 2.58753 10.7291C2.58753 11.6738 2.92146 12.4802 3.58932 13.148C4.25719 13.8159 5.06351 14.1498 6.00829 14.1498H8.45169V16.1045H6.00829Z"
          fill="#113F4A"
        />
      </svg>
    </>
  );
};


export const StatusInActive = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-toggle-off text-green-500" viewBox="0 0 16 16">
      <path d="M11 4a4 4 0 0 1 0 8H8a5 5 0 0 0 2-4 5 5 0 0 0-2-4zm-6 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8M0 8a5 5 0 0 0 5 5h6a5 5 0 0 0 0-10H5a5 5 0 0 0-5 5" />
    </svg>
  )
}

export const StatusActive = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-toggle-on" viewBox="0 0 16 16">
      <path d="M5 3a5 5 0 0 0 0 10h6a5 5 0 0 0 0-10zm6 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8" />
    </svg>
  )
}